var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-1 pa-0"},[_c('DevTables',{attrs:{"tblHeaders":_vm.tableHeader,"tblItems":_vm.tableItems,"tblHeight":"calc(100vh - 205px)","ppDate1":_vm.pDate1,"ppDate2":_vm.pDate2,"ppType":"DevState","trigger2":_vm.trigger}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }